function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Courses",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Edit-Course-Effort",
  transform: "translate(-25.000000, -314.000000)"
}, React.createElement("path", {
  d: "M38,314 L38,317.000125 L36.4705882,317.000125 L36.4705882,315.500063 L26.5294118,315.500063 L26.5294118,330.500688 L36.4705882,330.500688 L36.4705882,326.750531 L38,326.750531 L38,332 L25,332 L25,314 L38,314 Z M39.7048352,316 L43,319.295165 L33.2951648,329 L30,329 L30,325.705582 L39.7048352,316 Z M31.4930516,326.323705 L31.4930516,327.506948 L32.6770415,327.506948 L31.4930516,326.323705 Z M39.7048352,318.111921 L32.548639,325.266625 L33.7318824,326.452107 L40.8880786,319.295165 L39.7048352,318.111921 Z M30,323 L30,325 L28,325 L28,323 L30,323 Z M32,320 L32,322 L28,322 L28,320 L32,320 Z M34,317 L34,319 L28,319 L28,317 L34,317 Z",
  id: "Combined-Shape"
})));

var SvgIconCourses = function SvgIconCourses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCourses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-courses.e7268cb3.svg";
export { ForwardRef as ReactComponent };